import './../../css/src/main.scss';

import aguid from 'aguid';
import data from './data/data';
import config from './config/config';
import MobileDetect from 'mobile-detect';
import AppDispatcher from './dispatcher/AppDispatcher';
import AppConstants from './constants/AppConstants';
import renderHelper from './helpers/render';
import audioHelper from './helpers/audio';
import frameAnimationHelper from './helpers/frame-animation';
import textureHelper from './helpers/texture';
import router from './router/router';
import events from 'events';
import highScoreView from './views/high-score-view';
import './../vendor/fontdetect.js';


const app = {
  texturesLoaded: false,
  soundsLoaded: false,
  positionPauseGraphicsTimeout: 0,


  /**
   * Adds event listeners
   * @returns {undefined} undefined
   */
  setup() {
    const doc = document;
    const attach = 'addEventListener';

    if (doc[attach]) {
      doc[attach]('DOMContentLoaded', this.onDOMReady.bind(this));
    } else {
      window.attachEvent('onload', this.onDOMReady.bind(this));
    }
  },


  /**
   * Called when the DOM is ready
   * @returns {undefined} undefined
   */
  onDOMReady() {
    const md = new MobileDetect(window.navigator.userAgent);

    if (md.phone()) {
      const bodyEl = document.getElementsByTagName('BODY')[0];
      let newClass = bodyEl.className.split('desktop').join('');
      const os = md.os();

      if (os.toLowerCase().indexOf('android') > -1) {
        newClass += 'android';
      }

      if (os.toLowerCase().indexOf('ios') > -1) {
        newClass += 'ios';
      }

      bodyEl.className = newClass;
      this.preloadFont();
      this.getApiToken();
    } else {
      const desktopLandingImage =
        document.getElementsByClassName('landing-image')[0];
      const brLogo =
        document.getElementsByClassName('br-logo')[0];
      const uaLogo =
        document.getElementsByClassName('ua-logo')[0];

      desktopLandingImage.innerHTML =
        '<img src=\'assets/images/landing/desktop-landing.gif\' />';
      brLogo.innerHTML =
        '<img src=\'assets/images/intro/br-logo-white.png\' />';
      uaLogo.innerHTML =
        '<img src=\'assets/images/intro/ua-logo.png\' />';
    }
  },


  /**
   * Gets token to make api calls
   * @returns {undefined} undefined
   */
  getApiToken() {
    const formData = new FormData();
    window._sessionId = aguid();
    formData.append('sessionId', window._sessionId);

    // Get highest shot percentag scores
    fetch(config.apiEndpoint + 'tokens', {
      method: 'post',
      body: formData,
    }).then((response) => {
      return response.json();
    }).then((json) => {
      window._sessionToken = json.token;
    }).catch((ex) => {
      console.log('Failed to get token', ex);
    });
  },


  /**
   * Checks for the font to be loaded
   * @returns {undefined} undefined
   */
  preloadFont() {
    const _this = this;

    window.FontDetect.onFontLoaded('orbitron', () => {
      _this.init();
    });
  },


  /**
   * Sets everything up
   * @returns {undefined} undefined
   */
  init() {
    const appContainer = document.getElementsByClassName('app-container')[0];

    events.EventEmitter.defaultMaxListeners = Infinity;
    frameAnimationHelper.init(60);
    renderHelper.init(appContainer);
    highScoreView.init();

    textureHelper.preloadTextures(data.introPaths, this.doIntro.bind(this));
    window.addEventListener('orientationchange', this.onOrientationChange.bind(this));
    this.onOrientationChange();
  },


  /**
   * Plays the intro
   * @returns {undefined} undefined
   */
  doIntro() {
    router.navigate('intro');
    audioHelper.init(data.soundPaths, this.onAssetLoad.bind(this));
    textureHelper.preloadTextures(data.texturePaths, this.onAssetLoad.bind(this));
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onOrientationChange() {
    if (window.orientation) {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.PAUSE,
      });
    } else {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.UN_PAUSE,
      });
    }

    clearTimeout(this.positionPauseGraphicsTimeout);

    this.positionPauseGraphicsTimeout = setTimeout(() => {
      this.positionPauseGraphics();
    }, 50);
  },


  /**
   * Called when the assets are loaded
   * @param {String} assetType - The type of assets that are loaded
   * @param {Boolean} loadingComplete - If the loading for this type of assetType
   * is complete
   * @param {Number} loadCount - The load count for this type of asset
   * @param {Number} totalCount - The total count for this type of asset
   * @returns {undefined} undefined
   */
  onAssetLoad(assetType, loadingComplete, loadCount, totalCount) {
    let totalLoadPercentage = 0;

    if (assetType === 'textures' && loadingComplete) {
      this.texturesLoaded = true;
    }

    if (assetType === 'sounds') {
      if (!loadingComplete) {
        totalLoadPercentage += 0.5 * (loadCount / totalCount);
      }

      if (loadingComplete) {
        this.soundsLoaded = true;
      }
    }

    if (this.texturesLoaded) {
      totalLoadPercentage += 0.5;
    }

    if (this.soundsLoaded) {
      totalLoadPercentage += 0.5;
    }

    if (this.texturesLoaded && this.soundsLoaded) {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.MAIN_ASSETS_LOADED,
      });
    }
  },


  /**
   * Positions the pause graphics
   * @returns {undefined} undefined
   */
  positionPauseGraphics() {
    const randomTextInt = Math.floor(Math.random() *
      ((data.pausedData.length) - 0)) + 0;
    const stephImage = document.getElementsByClassName('steph')[0];
    const pauseViewContainer = document.getElementsByClassName('pause-view')[0];
    const pauseViewTitle = pauseViewContainer.getElementsByTagName('H1')[0];
    let stephImageTop = window.innerHeight - stephImage.offsetHeight;

    if (stephImageTop < 10) {
      stephImageTop = 10;
    }

    pauseViewTitle.innerHTML = data.pausedData[randomTextInt];
    stephImage.style.top = stephImageTop + 'px';
  },
};

/**
 * Loads the app
 * @param {Function} callback - The function to call
 * @returns {undefined} undefined
 */
app.setup();



/** WEBPACK FOOTER **
 ** ./assets/js/src/main.js
 **/